import { useMemo } from 'react';

function useProcessedLessonProgress(courseDocument, courseProgress) {
   const { completedLessonsSet, lastCompleteLesson } = useMemo(() => {
      let lastCompleteLesson;
      let lastCompleteDate;
      const completedLessonsSet = courseProgress.reduce((set, { id, date }) => {
         if (
            (lastCompleteDate == null && date != null) ||
            date > lastCompleteDate
         ) {
            lastCompleteLesson = id;
            lastCompleteDate = date;
         }
         return {
            ...set,
            [id]: true,
         };
      }, {});

      return { completedLessonsSet, lastCompleteLesson };
   }, [courseProgress]);

   const nextLesson = useMemo(() => {
      if (lastCompleteLesson == null) {
         return courseDocument.sections[0].lessons[0];
      }
      let lessonFound;
      let firstIncompleteLesson;
      for (let i = 0; i < courseDocument.sections.length; i++) {
         for (let j = 0; j < courseDocument.sections[i].lessons.length; j++) {
            const currentId = courseDocument.sections[i].lessons[j].id;
            const currentComplete = completedLessonsSet[currentId];
            if (lessonFound && !currentComplete) {
               return courseDocument.sections[i].lessons[j];
            }
            if (firstIncompleteLesson == null && !currentComplete) {
               firstIncompleteLesson = courseDocument.sections[i].lessons[j];
            }
            if (currentId === lastCompleteLesson) {
               lessonFound = true;
            }
         }
      }

      return firstIncompleteLesson;
   }, [courseDocument, completedLessonsSet, lastCompleteLesson]);

   return { completedLessonsSet, lastCompleteLesson, nextLesson };
}

export { useProcessedLessonProgress };
